import { boot } from './boot.js';

/**
 * Entry point for the hosted web surface.
 *
 * Kept to almost nothing so the interesting parts stay testable: `boot()` takes
 * a container and returns a handle, which is also what a future multi-page shell
 * would call on route change to tear WebMCP registrations down.
 */

declare global {
  interface Window {
    /** Escape hatch for manual poking in devtools during a live demo. */
    __clawharbor?: Awaited<ReturnType<typeof boot>>;
  }
}

function mount(): void {
  const container = document.getElementById('app');
  if (!container) {
    console.error('[clawharbor] no #app container in the document');
    return;
  }
  void boot(container).then((handle) => {
    window.__clawharbor = handle;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount, { once: true });
} else {
  mount();
}
